import {
  Heading as ChakraHeading,
  useStyles,
} from "@chakra-ui/react";

interface Props {
  node: { type: string; value: string; tagName: string };
  level: number;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Heading = ({ node, level, ...props }: Props) => {
  const styles = useStyles();
  const calculatedLevel = level ?? parseInt(node.tagName.substring(1)); // when node.tagName is `h2`, then `calculatedLevel` is 2
  const sizes = ["2xl", "xl", "lg", "md", "sm", "xs"];

  return (
    <ChakraHeading
      sx={styles.heading}
      {...props}
      // as={node.tagName as any}
      as={`h${calculatedLevel}` as "h1" | "h2" | "h3" | "h4" | "h5" | "h6"}
      fontStyle="italic"
      size={sizes[`${calculatedLevel - 1}`]}
    />
  );
};

export default Heading;
